
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code2 } from "./data";

export default defineComponent({
  name: "removeable-tag",
  data() {
    return {
      tags: [
        { name: "Tag 1", type: "" },
        { name: "Tag 2", type: "success" },
        { name: "Tag 3", type: "info" },
        { name: "Tag 4", type: "warning" },
        { name: "Tag 5", type: "danger" }
      ]
    };
  },
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code2
    };
  }
});
